import { usePlayerContainer } from './usePlayerContainer';

export const useContainerWidth = () => {
  const playerContainer = usePlayerContainer();

  return { containerWidth: playerContainer.clientWidth };
};
